export default {
  VERSION: '0.9.11.8',
};
